import { cn } from "@/common/utils/cn"
import { getConsumedPercentage } from "../services/getLayoutGovernmentAllocation"
import { GovernmentAllocationData } from "../types/governmentAllocation.type"
import { CompanyContractConsumptionControlledBy } from "@/features/company/types/contract.type"

function getConsumedPercentageStyle(
  governmentAllocation: GovernmentAllocationData,
  controlledBy?: CompanyContractConsumptionControlledBy,
) {
  if (controlledBy === CompanyContractConsumptionControlledBy.Quantity) {
    return '';
  }

  const consumedPercentage = Number(getConsumedPercentage({
    approved_value: governmentAllocation.approved_value,
    consumed_total: governmentAllocation.consumed_total,
  }))

  if (consumedPercentage >= 80) {
    return 'border-b-danger'
  } else if (consumedPercentage  >= 75) {
    return 'border-b-yellow-hover'
  }

  return 'border-b-success'
}

export const governmentAllocationStatusStyle = (
  governmentAllocation: GovernmentAllocationData,
  controlledBy?: CompanyContractConsumptionControlledBy,
) => ({
  pending: 'bg-[#5B5E57] border-l-yellow-600',
  active: cn(getConsumedPercentageStyle(governmentAllocation, controlledBy), 'bg-blue-700 border-b-8'),
  active_not_in_period: 'bg-[#2C2C2C] border-l-blue-700',
  expired: 'bg-[#2C2C2C] border-l-black-900',
  expired_with_credit: 'bg-[#766F70] border-l-red-500',
})
